import React from 'react';
import Badge from 'react-bootstrap/Badge';
import './MapImageButton.css';

interface MapImageButtonProps {
  alt: string;
  src: string;
  onClick: () => void;
}

function MapImageButton({ alt = '', src, onClick }: MapImageButtonProps) {
  const img = (
    <img
      src={src}
      alt={alt}
      loading="lazy"
      className="picture"
      style={{
        width: '100%',
      }}
    />
  );

  if (onClick) {
    return (
      <button className="mapImageButton" type="button" onClick={onClick}>
        {img}
        <div>
          <Badge bg="primary">View fullscreen</Badge>
        </div>
      </button>
    );
  }

  return img;
}

export default MapImageButton;
